import VerifyDetails from './VerifyDetails';

export default VerifyDetails;
